import { render } from "./thank_you.vue?vue&type=template&id=0be75673"
import script from "./thank_you.vue?vue&type=script&lang=js"
export * from "./thank_you.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__